(ns frontend.ui.page.lp-report-editor.step-1-initialization.card.feeder-configs
  (:require
   [frontend.ui.component.select-input.view :as select-input]
   [re-frame.core :as rf]
   [frontend.ui.component.table.view :as table]
   [potpuri.core :refer [dissoc-in]]
   [frontend.ui.page.lp-report-editor.common.view :as common-view]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.ui.page.lp-report-editor.step-1-initialization.sub :as sub]
   [frontend.ui.page.lp-report-editor.step-1-initialization.event :as event]
   [common.localization :as loc]
   [frontend.utils :as fu]
   [frontend.ui.component.icon.view :as icon-view]
   [frontend.ui.component.card.view :as card]
   [herb.core :refer [<class]]
   [frontend.ui.page.lp-report-editor.step-1-initialization.style :as style]
   [clojure.string :as string]
   [clojure.data :as data]
   [ui.components.button.view :as button]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.text-input.view :as text-input]))

(defn tools
  []
  (let [can-edit? @(rf/subscribe [::sub/can-edit? :step-4])
        edit-mode? @(rf/subscribe [::sub/edit-mode? :step-4])
        collapsed? @(rf/subscribe [::sub/collapsed? :step-4])]
    (concat []
            (when edit-mode?
              [[icon-view/icon
                {:class    (<class (fn [] {:margin-right "6px"}))
                 :on-click (fn [e]
                             (fu/prevent-default-event! e)
                             (rf/dispatch [::event/add-feeder]))}
                :add]])
            (when (and (not edit-mode?)
                       can-edit?)
              [[icon-view/icon
                {:class    (<class (fn [] {:margin-right "6px"}))
                 :on-click (fn [e]
                             (fu/prevent-default-event! e)
                             (rf/dispatch [::event/open-edit-mode :step-4])
                             (rf/dispatch [::event/init-feeders]))}
                :edit]])
            (when-not edit-mode?
              [[icon-view/icon
                {:on-click (fn [e]
                             (fu/prevent-default-event! e)
                             (rf/dispatch [::event/toggle-collapse :step-4]))}
                (if collapsed?
                  :angle-down
                  :angle-up)]]))))

(defn footer
  []
  (let [feeders @(rf/subscribe [::sub/feeder-edits])
        feeder-configs @(rf/subscribe [::sub/feeder-configs])
        [additions retracts _no-changes] (data/diff feeders feeder-configs)]
    [:div
     {:class (<class common-style/section-border-top)}
     #_[:div
        {:class (<class common-style/spacing-top)}
        [:div
         {:class (<class common-style/text-uppercase)}
         "Removed"]
        [:div (str retracts)]]
     #_[:div
        {:class (<class common-style/spacing-top)}
        [:div
         {:class (<class common-style/text-uppercase)}
         "Additions"]
        [:div (str additions)]]
     [:div
      {:class (<class common-style/footer-right)}
      [:div
       {:class (<class common-style/spacing-right)}
       [button/secondary-hollow
        {:on-click (fn [_e]
                     (rf/dispatch [::event/close-edit-mode :step-4])
                     (rf/dispatch [::event/reset-feeders]))}
        (loc/tr :cancel)]]
      [button/primary-solid
       {:disabled? (and (empty? additions)
                        (empty? retracts))
        :on-click  (fn [_]
                     (rf/dispatch [::event/save-feeders retracts additions]))}
       (loc/tr :save)]]]))

(defn edit-row
  [feeder tr-props td-props fund-options templates owners text-contributors data-contributors
   approvers]
  (let [feeder-id (:db/id feeder)]
    [:tr
     (assoc tr-props
            :key
            (str "lp-editor-feeder-" (:db/id feeder)))
     [:td td-props
      [select-input/select-input
       {:value     (:lp-report/fund feeder)
        :menu-porta-target-id "lp-report-step-4"
        :on-change #(rf/dispatch
                     [::event/feeder-change feeder-id :lp-report/fund %])}
       fund-options]]
     [:td td-props
      [select-input/select-input
       {:value     (:lp-report/template-type feeder)
        :menu-porta-target-id "lp-report-step-4"
        :on-change #(rf/dispatch
                     [::event/feeder-change feeder-id :lp-report/template-type %])}
       templates]]
     [:td td-props
      [text-input/text-input
       {:value     (:lp-report/title feeder)
        :on-change #(rf/dispatch [::event/feeder-change feeder-id :lp-report/title %])}]]
     [:td td-props
      [select-input/select-input
       {:multi?    true
        :value     (:lp-report/text-contributors feeder)
        :on-change #(rf/dispatch
                     [::event/feeder-change feeder-id :lp-report/text-contributors %])}
       text-contributors]]
     [:td td-props
      [select-input/select-input
       {:value     (:lp-report/text-approver feeder)
        :on-change #(rf/dispatch
                     [::event/feeder-change feeder-id :lp-report/text-approver %])}
       approvers]]
     [:td td-props
      [select-input/select-input
       {:multi?    true
        :value     (:lp-report/data-contributors feeder)
        :on-change #(rf/dispatch
                     [::event/feeder-change feeder-id :lp-report/data-contributors %])}
       data-contributors]]
     [:td td-props
      [select-input/select-input
       {:value     (:lp-report/data-approver feeder)
        :on-change #(rf/dispatch
                     [::event/feeder-change feeder-id :lp-report/data-approver %])}
       approvers]]
     [:td td-props
      [:i.fal.fa-trash-alt.clickable
       {:on-click (fn [e]
                    (fu/prevent-default-event! e)
                    (rf/dispatch [::event/remove-feeder feeder-id]))}]]]))

(defn display-row
  [feeder tr-props td-props fund-options templates owners text-contributors data-contributors
   approvers]
  [:tr tr-props
   [:td td-props
    (get (into {} fund-options) (:lp-report/fund feeder) (loc/tr :not-set))]
   [:td td-props
    (get (into {} templates) (:lp-report/template-type feeder) " ")]
   [:td td-props
    (or (:lp-report/title feeder) " ")]
   [:td td-props
    (->> feeder
         :lp-report/text-contributors
         (keep (fn [pid]
                 (get text-contributors pid)))
         (string/join ", "))]
   [:td td-props
    (get (into {} approvers) (:lp-report/text-approver feeder) " ")]
   [:td td-props
    (->> feeder
         :lp-report/data-contributors
         (keep (fn [pid]
                 (get data-contributors pid)))
         (string/join ", "))]
   [:td td-props
    (get (into {} approvers) (:lp-report/data-approver feeder) " ")]])

(defn view
  []
  (let [collapsed? @(rf/subscribe [::sub/collapsed? :step-4])
        edit-mode? @(rf/subscribe [::sub/edit-mode? :step-4])
        step-disabled? @(rf/subscribe [::sub/step-disabled? :step-4])
        step-completed? @(rf/subscribe [::sub/step-complete? :step-4])
        feeders @(rf/subscribe [::sub/feeders :step-4])
        feeder-fund-options @(rf/subscribe [::editor-sub/feeder-fund-options])
        selectable-feeder-fund-options @(rf/subscribe [::editor-sub/selectable-feeder-fund-options])
        templates @(rf/subscribe [::editor-sub/feeder-fund-templates])
        owners @(rf/subscribe [::editor-sub/report-owners])
        text-contributors @(rf/subscribe [::editor-sub/text-contributors])
        data-contributors @(rf/subscribe [::editor-sub/data-contributors])
        approvers @(rf/subscribe [::editor-sub/final-approvers])
        td-props (table/td-props {})
        tr-props (table/tr-props {})
        th-props (table/th-props {:styles (when edit-mode?
                                            {:min-width "220px"})})]
    [card/card-with-tools
     {:collapsed?       (or step-disabled? collapsed?)
      :disabled?        step-disabled?
      :toggle-collapsed #(rf/dispatch [::event/toggle-collapse :step-4])
      :icon             (if step-completed?
                          [common-view/icon-step-done]
                          [common-view/icon-step])
      :title            (loc/tr :lp-report-editor-step-4-title)
      :tool-icons       (when-not step-disabled?
                          (tools))}
     [:div (table/container-props)
      (if (empty? feeders)
        [:div
         (if-not edit-mode?
           (loc/tr :no-feeders)
           [:div
            {:class (<class common-style/no-content)}
            [:span
             (loc/tr :no-feeders-yet)]
            [button/secondary-hollow
             {:on-click #(rf/dispatch [::event/add-feeder])
              :label    (loc/tr :add)
              :icon     :i.fal.fa-plus-circle}
             (loc/tr :add)]])]
        [:table (table/table-props nil)
         [:thead
          [:tr (table/tr-props {})
           [:th th-props
            (loc/tr :fund)]
           [:th th-props
            (loc/tr :lp-report/template-type)]
           [:th th-props
            (loc/tr :lp-report/title)]
           [:th th-props
            (loc/tr :lp-report/text-contributors)]
           [:th th-props
            (loc/tr :lp-report/text-approver)]
           [:th th-props
            (loc/tr :lp-report/data-contributors)]
           [:th th-props
            (loc/tr :lp-report/data-approver)]
           (when edit-mode?
             [:th (table/th-props {})
              ""])]]
         [:tbody (table/tbody-props {})
          (doall
           (for [feeder feeders]
             (do
               (if edit-mode?
                 (edit-row feeder
                           tr-props
                           td-props
                           selectable-feeder-fund-options
                           templates
                           owners
                           text-contributors
                           data-contributors
                           approvers)
                 (display-row feeder
                              tr-props
                              td-props
                              feeder-fund-options
                              templates
                              owners
                              text-contributors
                              data-contributors
                              approvers)))))]])]
     (when edit-mode?
       [footer])]))
